import ConfirmIcon from "@mui/icons-material/CleaningServices";
import Button from "@mui/material/Button";
import { useConfirmDialog } from "~components/shared/ConfirmDialog/ConfirmDialogProvider";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { useOfflineContext } from "~contexts/OfflineContext/useOfflineContext.tsx";
import { resetAppData } from "./resetAppData";

export function ResetAppDataButton() {
  const { isOffline } = useOfflineContext();
  const t = useTranslation();
  const { openModal } = useConfirmDialog();

  return (
    <Button
      sx={{ mb: 4 }}
      variant="outlined"
      onClick={() =>
        openModal({
          onConfirm: resetAppData,
          confirmIcon: <ConfirmIcon />,
          confirmText: t.resetAppDataConfirmButtonText,
          title: t.resetAppDataConfirmTitle,
          message: t.resetAppDataConfirmText,
        })
      }
      disabled={isOffline}
    >
      {t.resetAppData}
    </Button>
  );
}
